import { Component, ElementRef, Input, NO_ERRORS_SCHEMA, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentService } from '../services/payment.service';
import { Subscription } from 'rxjs';
import { PaymentAmountComponent } from '../payment-amount/payment-amount.component';
import { PaymentCardDetailsComponent } from '../payment-card-details/payment-card-details.component';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-payment-form',
    imports: [ CommonModule, ReactiveFormsModule, PaymentAmountComponent, PaymentCardDetailsComponent ],
    templateUrl: './payment-form.component.html',
    styleUrl: './payment-form.component.scss',
    schemas: [ NO_ERRORS_SCHEMA ]
})
export class PaymentFormComponent implements OnInit, OnDestroy {

    @Input() paySecurelyButtonText: string = ""
    @Input() continuePaymentButtonText: string = ""
    @Input() enterAmountHeading: string = ""
    @Input() enterAmountSubHeading: string = ""
    @Input() enterAmountBody: string = ""
    @Input() cardDetailsHeading: string = ""
    @Input() cardDetailsSubHeading: string = ""
    @Input() cardDetailsBody: string = ""
    @Input() failedPaymentMessage: string = ""
    @Input() errorPaymentMessage: string = ""
    @Input() thankYouPageUrl: string = ""
    @Input() processingPaymentTitle: string = ""
    @Input() processingPaymentBody: string = ""
    @Input() paymentCardPageUrl: string = ""

    private subscription: Subscription | undefined;
    vm: any = {};

    constructor(private paymentService: PaymentService, private el: ElementRef) {
        this.vm.slides = {
            makePayment: "makePayment",
            makePaymentComplete: false,
            cardDetails: "cardDetails",
            cardDetailsComplete: false
        };

        this.vm.active = this.vm.slides.makePayment;
        this.vm.order = this.paymentService.getOrder();
        // this.paymentService.subscribeOrder(this.vm.order);
    }

    ngOnInit() {

        const cpt = this.el.nativeElement;
        this.paySecurelyButtonText = cpt.getAttribute("paySecurelyButtonText");
        console.log('paysetext');
        console.log(this.paySecurelyButtonText);
        this.continuePaymentButtonText = cpt.getAttribute("continuePaymentButtonText");
        this.enterAmountHeading = cpt.getAttribute("enterAmountHeading");
        this.enterAmountSubHeading = cpt.getAttribute("enterAmountSubHeading");
        this.enterAmountBody = cpt.getAttribute("enterAmountBody");
        this.cardDetailsHeading = cpt.getAttribute("cardDetailsHeading");
        this.cardDetailsSubHeading = cpt.getAttribute("cardDetailsSubHeading");
        this.cardDetailsBody = cpt.getAttribute("cardDetailsBody");
        this.failedPaymentMessage = cpt.getAttribute("failedPaymentMessage");
        this.errorPaymentMessage = cpt.getAttribute("errorPaymentMessage");
        this.thankYouPageUrl = cpt.getAttribute("thankYouPageUrl");
        this.processingPaymentTitle = cpt.getAttribute("processingPaymentTitle");
        this.processingPaymentBody = cpt.getAttribute("processingPaymentBody");
        this.paymentCardPageUrl = cpt.getAttribute("paymentCardPageUrl");


    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    save() {
        this.updateSlides();
        this.moveToNextSlide();
    }

    updateSlides() {
        switch (this.vm.active) {
            case this.vm.slides.makePayment:
                this.vm.slides.makePaymentComplete = true;
                break;
            case this.vm.slides.cardDetails:
                this.vm.slides.cardDetailsComplete = true;
                break;
        }
    }

    moveToNextSlide() {
        console.log('moveToNextSlide')
        switch (this.vm.active) {
            case this.vm.slides.makePayment:
                this.vm.active = this.vm.slides.cardDetails;
                this.vm.slides.makePaymentComplete = true;
                break;
            case this.vm.slides.cardDetails:
                // var orderCopy = this.vm.order;
                //  this.paymentService.setOrder({});
                break;
        }
    }

    paymentAmountComplete() {
        console.log('called');
        this.moveToNextSlide();
    }

    back() {
        switch (this.vm.active) {
            case this.vm.slides.cardDetails:
                this.vm.active = this.vm.slides.makePayment;
                break;
        }
    }
}
